// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import firebase from "firebase";
import "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyCC1z5Y-Jy1zoEmNCjpLUcG3RWqWpblMrU",
    authDomain: "memory-393e8.firebaseapp.com",
    databaseURL: "https://memory-393e8.firebaseio.com",
    projectId: "memory-393e8",
    storageBucket: "memory-393e8.appspot.com",
    messagingSenderId: "32939744653",
    appId: "1:32939744653:web:7d133b3337ba10d5daf1c4",
    measurementId: "G-H7Y4S3HBYN"
};
const firebaseApp = firebase.initializeApp(firebaseConfig); 
const db = firebaseApp.firestore();
const storage = firebaseApp.storage();

export { storage };
export default db;